/*---------------------------
| Helpers
---------------------------*/
import { UPLOAD_STATUSES } from "./constants";

export const getThisBatch = (batchId, batches) => {
    const thisBatch = batches.find(b => b.id === batchId);
    return thisBatch;
};

export const updateBatchesWithBatch = (mutatedBatch, batches) => {
    const newBatches = batches.map(b => {
        return b.id === mutatedBatch.id ? mutatedBatch : b;
    });
    return newBatches;
};

export const getThisUpload = (uploadId, uploads) => {
    const thisUpload = uploads.find(u => u.id === uploadId);
    return thisUpload;
};

export const updateUploadsWithUpload = (mutatedUpload, uploads) => {
    const newUploads = uploads.map(u => {
        return u.id === mutatedUpload.id ? mutatedUpload : u;
    });
    return newUploads;
};

// this function can also be used when the metadata
// section of the moderation project is being developed
// by adding metadata moderation-specific statuses to
// the conditions
export const uploadIsSavedForLater = upload => {
    if (upload.status === UPLOAD_STATUSES.VIS_MOD_SAVED_FOR_LATER) {
        return true;
    }

    if (upload.status === UPLOAD_STATUSES.VIS_MOD) {
        return false;
    }

    return false;
};

export const getCurrentViewUploadIds = selectedBatch => {
    const { currentView, visModActiveIds, visModSavedIds } = selectedBatch;
    return currentView === "active" ? visModActiveIds : visModSavedIds;
};

export const isOnlyWhiteSpace = str => {
    return /^\s*$/.test(str);
};
